import { Component, ElementRef, Input, OnInit, Output, ViewChild } from '@angular/core'
import { FormControl } from '@angular/forms'
import { Observable, Subject } from 'rxjs'

type Option = {
    value: any
    label: string
}

@Component({
    selector: 'app-auto-complete-select',
    templateUrl: './auto-complete-select.component.html',
    styleUrls: ['./auto-complete-select.component.scss'],
})
export class AutoCompleteSelectComponent implements OnInit {
    @Input() control: FormControl = new FormControl()
    @Input() placeholder: string = 'Escolha um item'
    @Input() options: Option[] = []
    @Input() filteredOptions$!: Observable<Option[]>

    @Output() selectOption = new Subject<Option>()
    @Output() hasOptionSelected = new Subject<boolean>()

    @ViewChild('input', { static: true })
    inputElement!: ElementRef<HTMLInputElement>

    constructor() {}

    ngOnInit(): void {}

    onSelect(option: Option) {
        this.selectOption.next(option)
        this.control.setValue(option.label)

        this.hasOptionSelected.next(true)
    }

    clear() {
        this.control.setValue(null)
        this.inputElement.nativeElement.value = ''
        this.hasOptionSelected.next(false)
    }
}
